export default {
  isLoggedIn(state) {
    return state.isLoggedIn;
  },

  isAvailableUncompletedResume(state) {
    return state.isAvailableUncompletedResume;
  },
};
